import { render, staticRenderFns } from "./AgencyManagement.vue?vue&type=template&id=7773347d&"
import script from "./AgencyManagement.vue?vue&type=script&lang=ts&"
export * from "./AgencyManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports